import {
  ResponseInitMedals,
  ResponseSearchMedals,
  ResponseTop50Medals,
} from '@/types/medals';
import { TEXTS, URLs, axiosErrorHandler } from '@/utils';
import axiosGdt, { axiosGdtWithoutCredentials } from '@/utils/axiosGdt';

export const initMedallero = axiosErrorHandler(async () => {
  const response = await axiosGdt.get<ResponseInitMedals>(
    `${URLs.MEDALLERO.INIT}&maxPags=500`
  );

  return response.data;
}, TEXTS.defaultError);

export const GetTop50Medals = axiosErrorHandler(async (id: string) => {
  const response = await axiosGdtWithoutCredentials.get<ResponseTop50Medals[]>(
    `${URLs.MEDALLERO.TOP50}${id}.json`
  );

  return response.data;
}, TEXTS.defaultError);

export const searchMedallero = axiosErrorHandler(async (search: string) => {
  const response = await axiosGdt.get<ResponseSearchMedals>(
    `${URLs.MEDALLERO.SEARCH}?search=${search}`
  );

  return response.data;
}, TEXTS.defaultError);
